import { ContactStatus } from '@wonderschool/common-base-types';
import { t } from 'i18next';
import { showErrorToast, showSuccessToast } from '../Components/Shared/showToast';

export function showInvitationSuccessToast(contact) {
  const { displayName, email } = contact;

  const message = t('contacts.invitation.successMessage', { displayName, email });
  showSuccessToast(t('contacts.invitation.successTitle'), message);
}

export function showInvitationErrorToast(contact, error) {
  const { displayName, email } = contact;
  const message = t('contacts.invitation.errorMessage', { displayName, email });
  showErrorToast(t('contacts.invitation.errorTitle'), message, error);
}

export function canSendInvitation(contact) {
  return [ContactStatus.new, ContactStatus.invited].includes(contact?.status) && !!contact?.email;
}
